const messages = {
  topbar: {
    kolobrzeg: "Kołobrzeg",
    back: "Powrót",
    favourites: "Schowek",
    chooseFloorOrFlat: "Wybierz piętro lub apartament",
    chooseFloor: "Wybierz piętro",
    chooseFlat: "Wybierz apartament",
    chooseBuilding: "Wybierz budynek",
    chooseInvestment: "Wybierz inwestycje",
    filtering: "Filtrowanie",
  },
  flat: "Apartament",
  floor: "Piętro",
  building: "Budynek",
  groundFloorShortcut: "P",
  tooltip: {
    flatNumber: "Ilość mieszkań",
    available: "Dostępne",
    booked: "Zarezerwowane",
    sold: "Sprzedane",
  },
  singleFlat: {
    area: "Powierzchnia",
    floor: "Piętro",
    groundFloor: "Parter",
    rooms: "Pokoje",
    price: "Cena",
    status: "Status",
    num: "Nr",

    noPrev: "Brak podglądu",
    similar: "Podobne apartamenty",
    askPrice: "Zapytaj o cenę",
    closeForm: "Zamknij formularz",
    downloadPDF: "Pobierz plan w PDF",
  },
  singleBuilding: {
    loading: "Ładowanie modułu 3D",
  },
  form: {
    title: "Zapytaj o apartament",
    name: "Imię i nazwisko",
    name_error: "Proszę podać imię i nazwisko",
    email: "E-mail",
    email_error: "Proszę podać email",
    phone: "Telefon",
    phone_error: "Proszę podać numer telefonu",
    message: "Wiadomość",
    message_error: "Proszę napisać wiadomość",
    check_error: "Proszę zatwierdzić zgodę",
    submit: "Zapytaj o apartament",
    sent: "Wysłano",
  },
  filters: {
    criteria: "Spełnia kryteria",
    remove: "Usuń filtry",
    amenities: "Udogodnienia",
    balcony: "Balkon",
    garden: "Ogród",
    search: "Wyszukaj",
  },
  favourites: {
    noCriteria: "Brak mieszkań spełniających wymagania",
    noFavs: "Brak mieszkań w schowku",
    placeholder: "Wpisz nazwę...",
    sortBy: "Sortuj według",
    sorting: "Wybierz sortowanie",
    openSort: "Otwórz opcje sortowania",
    findFlat: "Wyszukaj apartamenty",
    ascending: "rosnąco",
    descending: "malejąco",
    flatsIn: "Mieszkań w schowku",
    delete: "Usuń wszystkie",
  },
  pageNotFound: "Nie znaleziono strony",
  homepage: "Powrót na stronę główną",
  loadingFlats: "Ładowanie mieszkań",
  from: "od",
  to: "do",
  surface: "Metraż",
  rooms: "Liczba pokoi",

  agreeInfoShort: `Administratorem danych osobowych jest Vacation Investments Sp. z o.o. z
        siedzibą przy ulicy Mokotowskiej 57/19 w Warszawie...`,
  agreeInfo: `Administratorem danych osobowych jest Vacation Investments Sp. z o.o.
          z siedzibą przy ulicy Mokotowskiej 57/19 w Warszawie. Przysługuje Państwu
          prawo dostępu do swoich danych osobowych oraz prawo do ich usunięcia,
          poprawiania, ograniczenia przetwarzania oraz cofnięcia zgody na ich
          przetwarzanie. Podanie danych osobowych jest dobrowolne, wysyłając
          formularz wyrażają Państwo zgodę na ich przetwarzanie. Państwa
          dane będą przetwarzane w celach marketingowych również z
          wykorzystaniem zautomatyzowanego profilowania Podstawę prawną do
          przetwarzania Państwa danych osobowych stanowi art. 6 ust. 1 lit.a
          RODO czyli zgoda w przypadku jej udzielenia lub art. 6 ust. 1 lit.f
          RODO (ważny interes administratora marketing bezpośredni). Zakres
          przetwarzanych danych osobowych to imię, nazwisko, funkcja, telefon,
          adres e-mail. Dane będą przechowywane do momentu wniesienia przez
          Państwa sprzeciwu. Kontakt z administratorami danych jest możliwy
          poprzez email: marketing@hotelbalticwave.pl, tel. +48 882 784 606,
          oraz korespondencyjnie pod wskazany adres siedziby.`,
  agree1Short: `Wyrażam zgodę na przetwarzanie moich danych osobowych...`,
  agree1: `Wyrażam zgodę na przetwarzanie moich danych osobowych w postaci imienia i nazwiska, adresu e-mail, numeru telefonu, informacji dotyczących preferencji zakupowych i innych danych wskazanych w treści wiadomości oraz w zakresie informacji o mojej aktywności na stronie internetowej przez Vacation Investments Sp. z o.o., z siedzibą w Warszawie w celu marketingu bezpośredniego produktów i usług.`,
  agree2Short: `Wyrażam zgodę na prowadzenie marketingu bezpośredniego...`,
  agree2: `Wyrażam zgodę na prowadzenie marketingu bezpośredniego przy użyciu urządzeń telekomunikacyjnych przez VacationInvestments Sp. z o.o. z siedzibą w Warszawie, zgodnie z art. 172 ust. 1 ustawy z dnia 16 lipca 2004 r. Prawo telekomunikacyjne.`,
  agree3Short: `Wyrażam zgodę na otrzymywanie informacji handlowych od Vacation Investments Sp. z o.o. z siedzibą...`,
  agree3: `Wyrażam zgodę na otrzymywanie informacji handlowych od Vacation Investments Sp. z o.o. z siedzibą w Warszawie za pomocą środków komunikacji elektronicznej, zgodnie z art. 10 ust. 2 ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną.`,
  cardsView: "Widok kart",
  listView: "Widok listy",
  apartment: "Apartament",
  addToFavs: "Dodaj do ulubionych",
  removeFromFavs: "Usuń z ulubionych",
  loadMore: "Wczytaj więcej",
  matchingFlatsInfo: "Apartamenty spełniające Twoje kryteria",
};

export default messages;
